export default "__VITE_ASSET__DJY$brlW__"